'use strict';

const { getAllStates } = require('../statesRoot.js');

const statesConfig = window => ($stateProvider, $urlRouterProvider) => {
	$urlRouterProvider.otherwise('/');

	const states = getAllStates(window);

	states.forEach(function (state) {
		$stateProvider.state(state);
	});
};

const statesConfigFactory = window => {
	return { statesConfig: statesConfig(window) };
};

module.exports = {
	statesConfigFactory
};
